export default "__VITE_ASSET__CXtz2gmJ__"